import { Line2 } from "three/examples/jsm/lines/Line2";
import Formatting from "../../Helpers/Formatting";
import { SVGLabel } from "../../Overlays/SVGObjects";
import { SVGOverlay } from "../../Overlays/SVGOverlay";

export type MeasurementData = {
    measurement: string,
    startPos: THREE.Vector3,
    endPos: THREE.Vector3,
    startNormal: THREE.Vector3,
    endNormal: THREE.Vector3
}

export enum EMeasurementColors{
    GREEN = 'hsl(100,50%,50%)',
    LIGHT_GREEN =  'hsl(100,50%,60%)',
    DARK_GREEN =  'hsl(100,50%,40%)',
    BLUE = 'hsl(217,50%,50%)',
    LIGHT_BLUE = 'hsl(217,50%,60%)',
    DARK_BLUE = 'hsl(217,50%,40%)',
    RED = 'hsl(9,50%,50%)',
    LIGHT_RED = 'hsl(9,50%,60%)',
    DARK_RED = 'hsl(9,50%,40%)',
}
export abstract class BaseMeasurement {
    _mainMeasurement!: Line2;
    _startPos: THREE.Vector3;
    _endPos: THREE.Vector3;
    _startNormal: THREE.Vector3;
    _endNormal: THREE.Vector3;
    value: number | null = null;
    constructor(protected formatter: Formatting, startPos: THREE.Vector3, endPos: THREE.Vector3, startNormal: THREE.Vector3, endNormal: THREE.Vector3) {
        this._startPos = startPos;
        this._endPos = endPos;
        this._startNormal = startNormal;
        this._endNormal = endNormal;
    };
    abstract updatePoints(startPos: THREE.Vector3, endPos: THREE.Vector3, startNormal: THREE.Vector3, endNormal: THREE.Vector3);
    abstract addLabels(svgOverlay: SVGOverlay): SVGLabel[];
    toJSON(): string {
        return JSON.stringify(this.getData());
    }
    abstract getData(): MeasurementData;
     
}